import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _get from 'babel-runtime/helpers/get';
import _inherits from 'babel-runtime/helpers/inherits';
import { UpModule } from './upmodule';
export var UpAlbum = function (_UpModule) {
    _inherits(UpAlbum, _UpModule);

    function UpAlbum() {
        _classCallCheck(this, UpAlbum);

        return _possibleConstructorReturn(this, (UpAlbum.__proto__ || Object.getPrototypeOf(UpAlbum)).apply(this, arguments));
    }

    _createClass(UpAlbum, [{
        key: 'showPickerView',
        value: function showPickerView() {
            return this.generatePromiseByPluginFunctionWithParams('showPickerView');
        }
    }, {
        key: 'getErrorCodeAndText',
        value: function getErrorCodeAndText(_code) {
            if (_code === '230001') {
                return { msg: '无相机权限', code: '310001' };
            }
            if (_code === '230002') {
                return { msg: '无相册权限', code: '310002' };
            }
            if (_code === '230004') {
                return { msg: '裁剪失败', code: '310004' };
            }
            if (_code === '230003') {
                return { msg: '取消裁剪', code: '310003' };
            }
            return _get(UpAlbum.prototype.__proto__ || Object.getPrototypeOf(UpAlbum.prototype), 'getErrorCodeAndText', this).call(this, _code);
        }
    }]);

    return UpAlbum;
}(UpModule);